import { Component, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validators } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

import { Subject } from 'rxjs';
import { SelectBoxGroupModel } from 'src/app/model';
import { GeneralService } from 'src/app/shared/services';

@Component({
  selector: 'app-select-box-group',
  templateUrl: './select-box-group.component.html',
  styleUrls: ['./select-box-group.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SelectBoxGroupComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: SelectBoxGroupComponent
    }
  ]
})
export class SelectBoxGroupComponent implements OnInit {

  @Input() label: string = "";

  @Input() options: SelectBoxGroupModel[];

  @Input() appearance: MatFormFieldAppearance = 'fill';

  @Input() validator: boolean = false;

  @Input() formSubmit: boolean = false;

  @Output() valueChanged = new Subject<string>();

  get required(): boolean {
    return this.formControl?.hasValidator(Validators.required) ?? false;
  }

  // Control Value Accessor
  touched = false;
  disabled = false;
  validationStatus: ValidationErrors | null;
  value: string = "";
  formControl: AbstractControl;

  constructor(
    public generalService: GeneralService
  ) { }

  ngOnInit(): void { }

  /**
   * Determines whether selection change on
   * @param option
   */
  onSelectionChange(option: string) {
    this.valueChanged?.next(option);
    this.value = option;
    this.onChange(this.value);
  }

  onChange: Function;

  onTouched = () => {};

  /**
   * Writes value
   * @param value
   */
  writeValue(value: string) {
    this.value = value;
  }

  /**
   * Registers on change
   * @param onChange
   */
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  /**
   * Registers on touched
   * @param onTouched
   */
  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  /**
   * Marks as touched
   */
  markAsTouched() {    
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  /**
   * Sets disabled state
   * @param disabled
   */
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  /**
   * Validates select box component
   * @param control
   * @returns validate
   */
  validate(control: AbstractControl): ValidationErrors | null {
    this.formControl = control;
    this.validationStatus = null;
    return this.validationStatus;
  }

}
